// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__1DiNc","inputWrap":"styles_inputWrap__361KX","input":"styles_input__DsIRi"};